export const headRewrite = (title, description, keyword) => {
    document.title = title;
    const headData = document.head.children;
    for (let i = 0; i < headData.length; i++){
        const nameVal = headData[i].getAttribute('name');
        if(nameVal !== null){
            if(nameVal.indexOf('keyword') != -1){
                headData[i].setAttribute('content', keyword);
            }
            if(nameVal.indexOf('description') != -1){
                headData[i].setAttribute('content', description);
            }
        }
    }
}

//seo対策構造化マークアップのためにscriptの書き換えを行う機能
export const headScriptRewrite = (
  url,
  product_name,
  description,
  image_url,
  stock,
  rating,
  price
) => {
  // 正しいJSON-LDを生成して<head>内のscript[type="application/ld+json"]に反映する
  const normalizePrice = (p) => {
    if (p === null || p === undefined) return null;
    const cleaned = String(p).replace(/[^\d.]/g, '');
    return cleaned.length ? cleaned : null;
  };

  const normalizedPrice = normalizePrice(price);

  const data = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    url: url,
    name: product_name,
    description: description,
    image: image_url ? [image_url] : undefined,
    brand: {
      '@type': 'Brand',
      name: 'ブランド名',
    },
    offers: {
      '@type': 'Offer',
      url: url,
      priceCurrency: 'JPY',
      price: normalizedPrice, // 価格は数値文字列（例: "12000"）
      availability: stock ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
    },
  };

  // ratingが与えられていればAggregateRatingを付与
  if (rating !== null && rating !== undefined) {
    data.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: String(rating),
      reviewCount: 1,
    };
  }

  // 既存の構造化データscriptを検索（なければ新規作成）
  let script = document.querySelector('script[type="application/ld+json"][data-jsonld="product"]');
  if (!script) {
    script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-jsonld', 'product');
    document.head.appendChild(script);
  }

  // type属性ではなく、スクリプトの内容(テキスト)を書き換える
  script.text = JSON.stringify(data);
};
